import { useContext } from "react";
import { AuthenticatedContext } from "../providers";

export const useAuthenticated = () => {
  const context = useContext(AuthenticatedContext);
  if (context === undefined) {
    throw new Error("useAuthenticated must be used within an AuthProvider");
  }
  return context;
};
